// src/components/store/sections/faqs/FaqV31CyberterminalLimeZest.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV31CyberterminalLimeZest(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={31}
      archKey="cyber_terminal"
      archLabel="Cyber Terminal Help"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
